import { render, staticRenderFns } from "./CompaniesIndex.vue?vue&type=template&id=9212e530&scoped=true&"
import script from "./CompaniesIndex.vue?vue&type=script&lang=js&"
export * from "./CompaniesIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9212e530",
  null
  
)

export default component.exports